import { render, staticRenderFns } from "./AttendancePane.vue?vue&type=template&id=3d4a987f&scoped=true"
import script from "./AttendancePane.vue?vue&type=script&lang=js"
export * from "./AttendancePane.vue?vue&type=script&lang=js"
import style0 from "./AttendancePane.vue?vue&type=style&index=0&id=3d4a987f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4a987f",
  null
  
)

export default component.exports